import React, { useEffect } from 'react';

import HomeSlider from 'components/home/HomeSlider';
import SearchContainer from 'components/search/SearchContainer';
import { useModal } from 'context/ModalContext';
import { useSearchParams } from 'react-router-dom';
import { useRouteChangeHandler } from 'shared/hooks';
import { SeoMetaTags } from 'shared/ui';

const HomePage = () => {
  const { handleRouteChange } = useRouteChangeHandler();
  const [searchParams] = useSearchParams();
  const { openModal, MODAL_TYPES } = useModal();

  useEffect(() => {
    const state = searchParams.get('state');
    if (state) {
      if (state === MODAL_TYPES.RESET.toLowerCase()) {
        const modalType = state.toUpperCase();
        openModal(modalType);
      }
    }
  }, [searchParams]);

  return (
    <>
      <SeoMetaTags
        title="CheckmateKorea - Apartments & Studio Rooms in Korea | Housing for Foreigners"
        description="Looking for housing in Korea? CheckmateKorea helps international students and expats find verified apartments and studios near universities, with full contract and settlement support."
        keywords="Korea, housing, apartments, studio rooms, foreign students, expats, CheckmateKorea"
      />

      <div
        className="relative flex h-[calc(743px-143px)] w-full flex-col items-center justify-end pb-16"
        style={{
          backgroundImage:
            'linear-gradient(to bottom, white 10%, rgba(255,255,255,0) 40%), url(/images/optimized/home_bg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute left-0 top-[calc(181px-120px)] flex w-full flex-col items-center gap-y-12">
          <div className="flex w-full flex-col items-center gap-y-2.5">
            <h1 className="text-h3 text-primary">{`We Check, You Chill — your best home assistant`}</h1>
            <p className="text-b4 text-gray-40">
              With Checkmate, you can receive specific information
              <br />
              about local rooms and make reservations right from your bed
            </p>
          </div>
          <SearchContainer
            onSearch={({ originalWhere, whereType, whereValue, moveIn, contractPeriod, roomTypes }) => {
              const params = new URLSearchParams();
              if (originalWhere && whereType && whereValue) {
                params.append('originalWhere', originalWhere);
                params.append('whereType', whereType);
                params.append('whereValue', whereValue);
              }
              if (moveIn) params.append('moveIn', moveIn);
              if (contractPeriod) params.append('contractPeriod', contractPeriod);
              if (roomTypes) params.append('roomTypes', roomTypes);
              params.append('source', 'search');
              handleRouteChange(`/listing?${params.toString()}`);
            }}
          />
        </div>
        <div className="absolute bottom-0 left-0 h-[283px] w-full bg-gradient-to-t from-black/40 to-black/0" />
      </div>

      <section className="px- mx-auto mb-25 mt-20 flex w-full max-w-screen-2xl flex-col items-center gap-y-14">
        <div className="flex w-full flex-col items-center gap-y-2">
          <img src="/images/optimized/illusts/il_map.webp" alt="map" className="h-[82px] w-[82px] object-cover" />

          <h1 className="text-t1">Explore Areas Near University</h1>
        </div>
        <HomeSlider />
      </section>

      <div className="mx-auto mb-[194px] flex w-full max-w-[1184px] flex-col items-center gap-y-9">
        <a
          href="https://buttercup-coral-e9a.notion.site/Checkmate-Starter-Package-248c00e5608681f484bbede393efdff7"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/images/banner/mvp.png" alt="kozy_banner" className="w-full" />
        </a>
        <a
          href="https://buttercup-coral-e9a.notion.site/K-ozy-Bedding-Rental-Service-253c00e56086809da596d81c8bf9b660"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/images/banner/kozy.png" alt="mv_banner" className="w-full" />
        </a>
      </div>
    </>
  );
};

export default HomePage;
